import { render, staticRenderFns } from "./addStrategy.vue?vue&type=template&id=622ca9b6&scoped=true&"
import script from "./addStrategy.vue?vue&type=script&lang=js&"
export * from "./addStrategy.vue?vue&type=script&lang=js&"
import style0 from "./addStrategy.vue?vue&type=style&index=0&id=622ca9b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622ca9b6",
  null
  
)

export default component.exports